export default "__VITE_ASSET__DR2wkt_U__"